var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconError = function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Error_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Icon_Error_svg__cls-1{fill:none;stroke:current}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Icon_Error_svg__cls-1",
    x: 0.5,
    y: 3.5,
    width: 23,
    height: 17,
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon_Error_svg__cls-1",
    d: "M12 8v6M12 16v1"
  })));
};
export default SvgIconError;